import React, { Component } from "react";

class ZoomedHost extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			currentUserData: JSON.parse(localStorage.getItem('userData'))
		};
	}
	
	render() {
		return (
			<div className="stream_pop_holder d-none" id="zoomed_host">
				<div className="close_zoomed" id="zoom_out"></div>
				<div className="zoom_container" id="zoom_content"></div>
			</div>		
	)}
}
export default ZoomedHost;
